import { Center } from "@chakra-ui/react";
import { AppLoggedOutLayout } from "app/AppLoggedOutLayout";
import React from "react";
import { Outlet } from "react-router-dom";

export const AuthLayout: React.FC = () => (
  <AppLoggedOutLayout>
    <Center flex={1}>
      <Outlet />
    </Center>
  </AppLoggedOutLayout>
);
